module.exports = __webpack_public_path__ + "static/media/terrand_logo.4244826b.svg";